import '@fortawesome/fontawesome-free/css/solid.min.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import * as Icons from '@fortawesome/free-solid-svg-icons'

library.add(Icons.faTrash)
library.add(Icons.faUser)
library.add(Icons.faThLarge)
library.add(Icons.faSignOutAlt)
library.add(Icons.faBars)
library.add(Icons.faChevronUp)
library.add(Icons.faChevronDown)
library.add(Icons.faChevronRight)
library.add(Icons.faPlus)
library.add(Icons.faDownload)

// module/crm
library.add(Icons.faBuilding)
library.add(Icons.faTimes)
library.add(Icons.faStar)
library.add(Icons.faAddressCard)
library.add(Icons.faEllipsisV)
library.add(Icons.faPen)
library.add(Icons.faThList)
library.add(Icons.faMapMarkerAlt)
library.add(Icons.faStickyNote)
library.add(Icons.faCheckCircle)
library.add(Icons.faExclamationCircle)
library.add(Icons.faClipboardList)
library.add(Icons.faPhone)
library.add(Icons.faAt)
library.add(Icons.faCalendarAlt)
library.add(Icons.faUsers)
library.add(Icons.faUserPlus)
library.add(Icons.faCalendarPlus)
library.add(Icons.faCaretLeft)
library.add(Icons.faExchangeAlt)
library.add(Icons.faFilter)
library.add(Icons.faEnvelope)